import { render, staticRenderFns } from "./HomeViewRealtimeData.vue?vue&type=template&id=fbdc73f8&"
import script from "./HomeViewRealtimeData.vue?vue&type=script&lang=js&"
export * from "./HomeViewRealtimeData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports